module.exports = new __parcel__URL__("epa-other--cover.7a0fc72c.jpg").toString();